import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Badge from '@/components/common/Elements/Badge/Badge';
import { useUnreadCounts } from '@/components/myConversations/api';
import { useDispatch } from 'react-redux';

interface MyConversationsMenuItemProps {
  onClick?: () => void;
  isActive?: (match: any, location: any) => boolean;
  sidepanelStatus?: string;
}

const MyConversationsMenuItem: React.FC<MyConversationsMenuItemProps> = ({
  onClick,
  isActive,
  sidepanelStatus,
}) => {
  const { data: unreadCounts } = useUnreadCounts();

  // Calculate total unread count across all channels
  const totalUnread = unreadCounts
    ? Object.values(unreadCounts).reduce((sum, count) => sum + count, 0)
    : 0;

  const dispatch = useDispatch();

  useEffect(() => {
    // Keep the global notes unread count in sync with messaging backend counts
    dispatch({ type: 'SET_NOTES_ALL_COUNT', count: totalUnread });
  }, [dispatch, totalUnread]);

  return (
    <NavLink
      to="/my-conversations"
      onClick={onClick}
      isActive={isActive}
      data-tooltip-id="menu_project_item_My Conversations"
      className="my-conversations-menu-item "
    >
      {/* <i className="material-icons tw-position-relative">chat</i> */}
      <div className="tw-relative tw-inline-block">
        <i className="material-icons">chat</i>

        {/* Icon-only red dot positioned top-right of icon */}
        {sidepanelStatus === 'icon-only' && totalUnread > 0 && (
          <span
            className="tw-absolute tw-top-0 tw-right-0 tw-w-4 tw-h-4 tw-bg-cfo-red-400 tw-rounded-full tw-border tw-border-white"
            aria-hidden="true"
            title="You have unread conversations"
          />
        )}
      </div>

      {sidepanelStatus !== 'icon-only' ? (
        <>
          <span className="menu-label">My Conversations</span>
          {totalUnread > 0 && (
            <Badge
              label={totalUnread.toString()}
              className="unread-badge tw-bg-[#D34A46]"
            />
          )}
        </>
      ) : null}
    </NavLink>
  );
};

export default MyConversationsMenuItem;
